import { adminApi, errorMessage } from '../../administration/api';
import { VORLAGEN_TEXTE as T } from './vorlagenTexte';

// Profil-Nachbau F-20 Ergänzung 3 (Bennys Freigabe 14.10.2026, BAU-VORLAGEN.md 3.2): Typen und Wege der Vorlagen für
// Rechtsfragen, alle unter /api/administration (adminApi). Jede ändernde Anfrage schickt einen JSON-Körper (sonst 415).
// Der Server entschlüsselt Titel, Kurzbeschreibung, Text und Ordnernamen; die Oberfläche sucht in der entschlüsselten Liste.

export type Ablage = 'PERSON' | 'FIRMA';
// verwendungen nur bei Firmenvorlagen und nur mit darfPflegen; zuletztVerwendetAm nur bei persönlichen.
export interface Vorlage { id: string; ebene: Ablage; ordnerId: string | null; titel: string; kurzbeschreibung: string; text: string;
  rechtsgebiet: string | null; verwendungen?: number; zuletztVerwendetAm: string | null; updatedAt: string; revision: number }
export interface Ordner { id: string; ebene: Ablage; name: string; revision: number }
// Beispiele des Betreibers (veröffentlicht, nach reihenfolge). updatedAt nennt der Vertrag nicht; liefert der Server es, bietet
// der Reiter „Beispiele“ auch „Zuletzt geändert“.
export interface Beispiel { id: string; rechtsgebiet: string; titel: string; kurzbeschreibung: string; text: string; updatedAt?: string }
export interface VorlagenFirma { id: string; name: string; darfPflegen: boolean; ordner: Ordner[]; vorlagen: Vorlage[] }
export interface VorlagenStand {
  meine: { ordner: Ordner[]; vorlagen: Vorlage[] };
  firma: VorlagenFirma | null;
  beispiele: Beispiel[];
  rechtsgebiete: { schluessel: string; wort: string }[];
  grenzen: { personVorlagen: number; personOrdner: number; firmaVorlagen: number; firmaOrdner: number };
}
export type VorlageEingabe = { ordnerId: string | null; titel: string; kurzbeschreibung: string; text: string; rechtsgebiet: string | null };

const pfad = (id: string) => `/vorlagen/${encodeURIComponent(id)}`;
const ordnerPfad = (id: string) => `/vorlagen/ordner/${encodeURIComponent(id)}`;
const beispielPfad = (id: string) => `/vorlagen/beispiele/${encodeURIComponent(id)}`;

export const vorlagenApi = {
  stand: (signal?: AbortSignal) => adminApi.get<VorlagenStand>('/vorlagen', signal),
  startseite: (signal?: AbortSignal) => adminApi.get<{ beispiele: Beispiel[] }>('/vorlagen/startseite', signal),
  anlegen: (eingabe: VorlageEingabe & { ebene: Ablage }) => adminApi.post<{ vorlage: Vorlage }>('/vorlagen', eingabe),
  aendern: (id: string, eingabe: VorlageEingabe & { expectedRevision: number }) => adminApi.put<{ vorlage: Vorlage }>(pfad(id), eingabe),
  entfernen: (id: string, expectedRevision: number) => adminApi.post<{ ok: true }>(`${pfad(id)}/entfernen`, { expectedRevision }),
  kopieren: (id: string, ziel: Ablage, ordnerId: string | null) => adminApi.post<{ vorlage: Vorlage }>(`${pfad(id)}/kopieren`, { ziel, ordnerId }),
  verwendet: (id: string) => adminApi.post<{ ok: true }>(`${pfad(id)}/verwendet`, {}),
  beispielUebernehmen: (id: string, ziel: Ablage, ordnerId: string | null) => adminApi.post<{ vorlage: Vorlage }>(`${beispielPfad(id)}/uebernehmen`, { ziel, ordnerId }),
  beispielVerwendet: (id: string) => adminApi.post<{ ok: true }>(`${beispielPfad(id)}/verwendet`, {}),
  ordnerAnlegen: (ebene: Ablage, name: string) => adminApi.post<{ ordner: Ordner }>('/vorlagen/ordner', { ebene, name }),
  ordnerUmbenennen: (id: string, name: string, expectedRevision: number) => adminApi.put<{ ordner: Ordner }>(ordnerPfad(id), { name, expectedRevision }),
  ordnerEntfernen: (id: string, expectedRevision: number) => adminApi.post<{ ok: true; verschoben: number }>(`${ordnerPfad(id)}/entfernen`, { expectedRevision }),
};

type Fehlerantwort = { response?: { status?: number; data?: { code?: string } } };
export const fehlerCode = (fehler: unknown) => (fehler as Fehlerantwort)?.response?.data?.code;
// V-11: in einer Sicht des Betreibers sind die Wege gesperrt (403 OPERATOR_VIEW_SCOPE); die Seite fragt dann nicht weiter.
export const istSicht = (fehler: unknown) => (fehler as Fehlerantwort)?.response?.status === 403 && fehlerCode(fehler) === 'OPERATOR_VIEW_SCOPE';

/** Der Satz zu einem Fehler: Grenze erreicht (409 VORLAGEN_GRENZE) mit der Zahl der Ablage, sonst der Satz des Servers. */
export function vorlagenFehler(fehler: unknown, grenze: { anzahl: number; ordner?: boolean }): string {
  if (fehlerCode(fehler) === 'VORLAGEN_GRENZE') return grenze.ordner ? T.grenzeOrdner(grenze.anzahl) : T.grenzeVorlagen(grenze.anzahl);
  return errorMessage(fehler);
}

/** Die Grenze der Ablage aus GET /vorlagen (3.1: Person 200 und 30, Firma 500 und 50). */
export const grenzeDer = (stand: VorlagenStand, ebene: Ablage, ordner = false) => ({
  anzahl: ebene === 'FIRMA' ? (ordner ? stand.grenzen.firmaOrdner : stand.grenzen.firmaVorlagen) : (ordner ? stand.grenzen.personOrdner : stand.grenzen.personVorlagen),
  ordner,
});
